import { useEffect, useState } from 'react';

import { TOP_BAR_TRANSITION_TIME, TopBarBlock } from '../config';

type TopBarBlockTransition = {
  isHiding: boolean;
  visibleBlock: TopBarBlock;
};

/**
 * The outgoing block must stay mounted for the whole fade-out: unmounting it at
 * target-change time would cut the animation mid-flight and flash the new block
 * in before the old one is gone.
 */
export const useTopBarBlockTransition = (
  targetBlock: TopBarBlock,
): TopBarBlockTransition => {
  const [visibleBlock, setVisibleBlock] = useState<TopBarBlock>(targetBlock);
  const isHiding = targetBlock !== visibleBlock;

  useEffect(() => {
    if (!isHiding) {
      return;
    }

    const timer = setTimeout(() => {
      setVisibleBlock(targetBlock);
    }, TOP_BAR_TRANSITION_TIME);

    return () => {
      clearTimeout(timer);
    };
  }, [targetBlock, isHiding]);

  return { isHiding, visibleBlock };
};
